import React, { useState } from 'react';

import { Radio } from 'components/cosmos';
import { translate } from 'components/translate';
import { REASONS_BLOCK } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

import OthersInput from './OtherInput';
import { listReasonsBlocks } from './utils/reasons';

import './FormReasonsBlock.scss';

const FormReasonsBlock = ({ onChangeReason, onChangeOtherText, t }) => {
  const [reasonSelected, setReason] = useState('');

  const { OTHERS } = REASONS_BLOCK;

  const handleClick = (value) => {
    setReason(value);
    onChangeReason(value);
  };

  return (
    <div className="form-reasons-block">
      {listReasonsBlocks.map(({ id, label, value }) => (
        <Radio
          id={`form-reasons-block-${id}`}
          key={id}
          name="r1"
          value={value}
          label={t(label)}
          checked={reasonSelected === value}
          onClick={() => handleClick(value)}
        />
      ))}
      {reasonSelected === OTHERS && (
        <OthersInput
          show={Boolean(reasonSelected)}
          onChange={onChangeOtherText}
        />
      )}
    </div>
  );
};

FormReasonsBlock.propTypes = {
  onChangeReason: PropTypes.func.isRequired,
  onChangeOtherText: PropTypes.func.isRequired
};

export default translate()(FormReasonsBlock);
